import { IButtonStyles } from "@fluentui/react";
import {
  concatStyleSets,
  ITheme,
  mergeStyles,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  ActionControlSemanticColors,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineToggledOn,
  getActionControlSemanticColorsWithTheme,
  getBaseButtonStyles,
} from "@1js/acui-common";
import { isThemingEnabled } from "@1js/acui-theme";

import { IPivotStyles } from "./Pivot.Props";

export const getPivotHeaderOverflowButtonStyles = memoizeFunction(
  (theme: ITheme, customStyles?: IButtonStyles): IButtonStyles => {
    const baseButtonStyles: IButtonStyles = getBaseButtonStyles(theme);
    const actionControlSemanticColors: ActionControlSemanticColors =
      getActionControlSemanticColorsWithTheme(theme);
    const themingEnabled = isThemingEnabled();

    const defaultOverflowButtonStyles: IButtonStyles = {
      root: {
        height: 40,
        backgroundColor: actionControlSemanticColors.defaultBackgroundColor,
        color: themingEnabled ? theme.palette.black : "#000000",
        padding: "0 10px",
      },
      rootExpanded: [
        commonHighContrastOutlineToggledOn,
        commonHighContrastHoverFocusStyles,
      ],

      rootHovered: {
        color: themingEnabled
          ? actionControlSemanticColors.textColor
          : "#212121",
      },

      rootPressed: [
        {
          backgroundColor: themingEnabled
            ? theme.palette.neutralSecondaryAlt
            : "#969696",
          color: themingEnabled ? theme.palette.black : "black",
        },
        commonHighContrastHoverFocusStyles,
      ],
    };

    return concatStyleSets(
      baseButtonStyles,
      defaultOverflowButtonStyles,
      customStyles
    )!;
  }
);

export const getPivotStyles = memoizeFunction((styles?: IPivotStyles) => {
  return {
    root: mergeStyles(
      {
        display: "inline-block",
        verticalAlign: "top",
      },
      styles && styles.root
    ),
  };
});
